import { prop } from 'ramda';

import { useAppSelector, useDeviceSelector } from '@core/js/store/hooks';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';

export const useClientTypeAndPlatform = () => {
    const clientType = useAppSelector(prop('clientType'));
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));

    const {
        config: {
            customClientType,
            customClientPlatform
        }
    } = useRegistrationSelector();

    return {
        clientType: customClientType || clientType,
        clientPlatform: customClientPlatform || clientPlatform
    };
};
